import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import HomeLayout from '~/layouts/HomeLayout';

// ----------------------------------------------------------------------

const HomeRoutes = {
  path: '*',
  layout: HomeLayout,
  routes: [
    {
      exact: true,
      path: '/',
      component: lazy(() => import('src/views/home/LandingPageView'))
    },

    {
      component: props => {
        return (
          <Redirect to={'/404?origin=' + encodeURI(props.location.pathname)} />
        );
      }
    }
  ]
};

export default HomeRoutes;
